import { type BUSINESS_REDUCER_KEY, businessSelectors } from 'app-components/flux/business';
import { type DATE_REDUCER_KEY, dateSelectors } from 'app-components/flux/date';
import type { MILEAGE_TRACKER_REDUCER_KEY } from 'app-components/flux/mileage-tracker/mileageTrackerTypes';
import { createManagerFactory, formBuilder } from 'app-components/utils/createForm/formBuilder';
import type RootState from 'app-components/utils/redux-store/rootState';

export enum DeductionType {
  STANDARD = 'STANDARD',
  ACTUAL = 'ACTUAL',
}

type DeductionFormType = {
  taxYear: string;
  businessId: string;
  deductionType: DeductionType;
};
type ReduxState = Pick<
  RootState,
  typeof DATE_REDUCER_KEY | typeof BUSINESS_REDUCER_KEY | typeof MILEAGE_TRACKER_REDUCER_KEY
>;

const simpleFormClearState: DeductionFormType = {
  taxYear: '',
  businessId: '',
  deductionType: DeductionType.STANDARD,
};

const init = ({ input, store }: { input: Partial<DeductionFormType>; store: ReduxState }): DeductionFormType => {
  const taxYearInit = String(dateSelectors.getCurrentDate(store).year);
  const defaultBusiness = businessSelectors.getDefaultBusiness(store)?.id || 'PERSONAL';
  return {
    ...simpleFormClearState,
    ...input,
    taxYear: input.taxYear ?? taxYearInit,
    businessId: input.businessId ?? defaultBusiness,
  };
};

const mileageDeductionForm = formBuilder({ init })
  //   .addField('taxYear', { PHASE 2
  //     selector: (state) => state.taxYear ?? '',
  //     onValueChange: (draft, value: string) => {
  //       draft.taxYear = value;
  //     },
  //     validation: {
  //       required: {
  //         triggers: ValidationTrigger.onSubmit,
  //         isValid: ({ taxYear }) => !!taxYear,
  //         error: 'Required',
  //       },
  //     },
  //   })
  //   .addField('businessId', {
  //     selector: (state) => state.businessId ?? '',
  //     onValueChange: (draft, value: string) => {
  //       draft.businessId = value;
  //     },
  //     validation: {
  //       required: {
  //         triggers: ValidationTrigger.onSubmit,
  //         isValid: ({ businessId }) => !!businessId,
  //         error: 'Required',
  //       },
  //     },
  //   })
  .addField('deductionType', {
    selector: (state) => state.deductionType,
    onValueChange: (draft, value: DeductionType) => {
      draft.deductionType = value;
    },
  })
  .build({
    submitTransform(state): {
      deductionType: DeductionType; // change back to DeductionFormType when those are implemented
    } {
      return { deductionType: state.deductionType };
      //   return {
      //     ...state,
      //   };
    },
  });

export const mileageDeductionFormFactory = createManagerFactory(mileageDeductionForm);
